/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_CloseInputs */

const en_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const ar_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق`)
};

const bn_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বন্ধ করুন`)
};

const de_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const es_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const fr_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const pt_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const zh_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const tr_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapat`)
};

const ru_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

const pl_ui_close = /** @type {(inputs: Ui_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Ui_CloseInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ui_close = /** @type {((inputs?: Ui_CloseInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_CloseInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_close(inputs)
	if (locale === "bn") return bn_ui_close(inputs)
	if (locale === "de") return de_ui_close(inputs)
	if (locale === "es") return es_ui_close(inputs)
	if (locale === "fr") return fr_ui_close(inputs)
	if (locale === "pt") return pt_ui_close(inputs)
	if (locale === "zh") return zh_ui_close(inputs)
	if (locale === "tr") return tr_ui_close(inputs)
	if (locale === "ru") return ru_ui_close(inputs)
	if (locale === "pl") return pl_ui_close(inputs)
	return en_ui_close(inputs)
});